import { useState, useEffect } from 'react';
import { useSettings } from '../../hooks';
import { useUsingWalnutSettings } from '../../WhiteLabelSettings/Walnut/useUsingWalnutSettings';
import { useWhiteLabelGoogleTag } from '../useWhiteLabelGoogleTag/useWhiteLabelGoogleTag';

import { Products } from './types';

export const useWalnutGoogleAnalytics = () => {
  const {
    settings: { googleAnalyticsToken },
  } = useSettings();
  const onWalnut = useUsingWalnutSettings();
  const [sponsorCode, setSponsorCode] = useState<string>('');
  const analytics = useWhiteLabelGoogleTag(
    onWalnut ? googleAnalyticsToken : undefined,
    {
      product: Products.Commercial,
      sponsorCode: sponsorCode || undefined,
    },
  );

  // set the sponsor code on load (NB won't work on development)
  useEffect(() => {
    const host = window.location.host.toLowerCase();
    const sponsorCode = host.split('.')[0];
    setSponsorCode(sponsorCode);
  }, []);

  //console.log('About to return analytics', analytics);
  return analytics;
};
